import { render, staticRenderFns } from "./channelSdkConfigDeatils.vue?vue&type=template&id=59bc9fa0&scoped=true"
import script from "./channelSdkConfigDeatils.vue?vue&type=script&lang=js"
export * from "./channelSdkConfigDeatils.vue?vue&type=script&lang=js"
import style0 from "./channelSdkConfigDeatils.vue?vue&type=style&index=0&id=59bc9fa0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc9fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bc9fa0')) {
      api.createRecord('59bc9fa0', component.options)
    } else {
      api.reload('59bc9fa0', component.options)
    }
    module.hot.accept("./channelSdkConfigDeatils.vue?vue&type=template&id=59bc9fa0&scoped=true", function () {
      api.rerender('59bc9fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/channelSdkConfigDeatils.vue"
export default component.exports